module.exports = __webpack_public_path__ + "static/media/logo_disneychannel.28adecce.jpg";